import { useApi } from "hooks"
import { useQuery } from "@tanstack/react-query"

const useGetDetail = ({ daysFrom = '', page = 0 }) => {
  const { apiFetch } = useApi()

  const resultsPerPage = 1000000
  const url = `/payments/creator/contents/earnings?daysFrom=${daysFrom}&page=${page}&amountPerPage=${resultsPerPage}`

  const getDetail = () => {
    return apiFetch({ url })
      .then(res => res.data)
  }

  const options = {
    staleTime: 30000, // 30 seg
  }

  return useQuery(['creators-detail', daysFrom, page, 'lang'], getDetail, options)
}

export default useGetDetail